import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';

import {map, mergeMap, Observable, of, take} from 'rxjs';
import {ENV} from '../../app/config/module.di.tokens';
import {dot} from '../strings';
import {AuthStateService} from '../../services/auth-state.service';

const HEADER_GATEWAY_USERINFO = "X-Endpoint-API-UserInfo"
const HEADER_API_AUTH = "Authorization"

function needsAuth(request: HttpRequest<unknown>): boolean {
  return request.url.includes('/api/my-account') || request.url.includes('/api/contacts/me') || request.url.includes('my-account-meeting-profiles');
}

export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  let obs = next(request);

  if (needsAuth(request)) {

    const env = inject<'dev' | 'prd'>(ENV);
    const authState = inject(AuthStateService);

    obs = authState.user$.pipe(
      take(1),
      mergeMap((user) => (user ? user.getIdToken() : of(null))),
      map((idToken) => request.clone({ setHeaders: authHeaders(request, idToken, env) })),
      mergeMap((req) => next(req)),
    );
  }

  return obs;
}

function authHeaders(request: HttpRequest<any>, idToken: string, env: 'dev' | 'prd') {
  let headers = {};
  if(idToken) {
    if(env == 'dev') {
      const jwtParts = idToken.split(dot)
      headers[HEADER_GATEWAY_USERINFO] = jwtParts[1]
    } else {
      headers[HEADER_API_AUTH] = `Bearer ${idToken}`
    }
  }
  return headers
}
